import React, { Component } from 'react';

export default class CommissionLabel extends Component {
  render() {
    const { isPackage } = this.props;

    if (!isPackage) {
      return '';
    }

    return (
      <p
        style={{
          padding: 6,
          borderRadius: '8px',
          backgroundColor: 'yellow',
        }}
      >
        <b>*MODO PAQUETE* </b>- Recuerda incluir el costo de todos los servicios
        en la tarifa del <b>Hospedaje</b>
      </p>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/SalePackageLabel.js